/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {deleteExternalSendSafelyRecipients} from '../api'

export const useMutationDeleteExternalSendSafelyRecipients = createReactQueryMutationHook('deleteExternalSendSafelyRecipients', deleteExternalSendSafelyRecipients)
